import { AxiosResponse } from "axios";
import { Option } from "Components/AppGrid/shipeezi-new-grid";

import API from "../api";
import { Milestone } from "../models/milestone";

import { PurchaseOrder } from "../models/purchase.order";

import BaseService from "./_base.service";
import { GetAndCountAll } from "./_base";

const ROUTE_NAME = "purchaseorders";

interface PurchaseOrderListResponse {
  data: PurchaseOrder[];
  total: number;
}

const PurchaseOrderService = {
  ...BaseService<PurchaseOrder>({ endpoint: ROUTE_NAME }),
  async getById(id: number, options?: any): Promise<AxiosResponse<PurchaseOrder>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getByCompanyId(
    companyId: number,
    options?: any
  ): Promise<AxiosResponse<PurchaseOrderListResponse>> {
    return await API.get(`/${ROUTE_NAME}/products/onhand/${companyId}`, { params: options });
  },
  async create(purchaseOrder: PurchaseOrder): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}`, purchaseOrder);
  },
  async delete(id: number): Promise<AxiosResponse<boolean>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async getStatuses(): Promise<AxiosResponse<Option[]>> {
    return await API.get(`/${ROUTE_NAME}/status`);
  },
  async getMilestoneDates(options?: any): Promise<AxiosResponse<Milestone[]>> {
    return await API.get(`/${ROUTE_NAME}/milestones`, { params: options });
  },
  async getAvailableList(options?: any): Promise<AxiosResponse<GetAndCountAll<PurchaseOrder>>> {
    return await API.get(`/${ROUTE_NAME}/available/list`, { params: options });
  },
  async getAvailableShipmentList(
    options?: any
  ): Promise<AxiosResponse<GetAndCountAll<PurchaseOrder>>> {
    return await API.get(`/${ROUTE_NAME}/available/shipment/list`, { params: options });
  },
  async cancelOrders(orderIds?: number[]): Promise<AxiosResponse<boolean[]>> {
    return await API.post(`/${ROUTE_NAME}/cancel`, { orderIds });
  },
};

export default PurchaseOrderService;
